module.exports = __webpack_public_path__ + "img/calendar-plus.e0f12931.svg";